import { queryOptions, useQuery } from "tanstack-react-query-5";

import { getUserInfo } from "../request.auth";

const getUserInfoOptions = () => {
  return queryOptions({
    queryKey: ["getUserInfo"],
    queryFn: getUserInfo,
    // the query will refetch every 5 minutes.
    staleTime: 5 * 60 * 1000,
  });
};

const useGetUserInfo = () => {
  return useQuery(getUserInfoOptions());
};

export { getUserInfoOptions, useGetUserInfo };
